export default __webpack_public_path__ + "static/ShimmerArt-3c7d898fdc7742e16c9ccfe51493f53e.jpg";